import IAppState from "../models/IAppState"
import IAuth from "../models/IAuth";
import { AuthUser } from "../models/IAuth";
import CasinoSortEnum from "../models/CasinoSortEnum";
import { readBool, readJSON, readString, STORAGE_KEYS } from "./persistence";


function hydrateSortFieldType(): CasinoSortEnum {
    const raw = readString(STORAGE_KEYS.casinoSortFieldType, '');
    const valid = Object.values(CasinoSortEnum) as string[];
    return valid.includes(raw) ? (raw as CasinoSortEnum) : CasinoSortEnum.None;
}

function hydrateAuthUser(): AuthUser | null {
    return readJSON<AuthUser | null>(STORAGE_KEYS.authUser, null);
}

export default function createInitialAppState(auth: IAuth): IAppState {
    const cachedUser = hydrateAuthUser();
    return {
        okDialog: {
            open: false,
            title: "",
            text: ""
        },
        casinoSearch: {
            searchText: readString(STORAGE_KEYS.casinoSearchText, ''),
            sortFieldType: hydrateSortFieldType(),
        },
        auth: {
            ...auth,
            authUser: cachedUser,
            isAuthenticated: !!cachedUser,
        },
        userPoints: null,
        userPreferences: {
            displayCraps: true,
            displayBlackjack: true,
            displayRoulette: true,
        },
        isOnMobileDevice: false,
        clientConfig: null,
        homeFavoritesOnly: readBool(STORAGE_KEYS.homeFavoritesOnly, false),
        favoriteOverrides: {},
        pwa: {
            updateAvailable: false,
            offlineReady: false,
            isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
        },
    }
}

export const initialAppState: IAppState = {
    okDialog: {
        open: false,
        title: "",
        text: ""
    },
    casinoSearch: {
        searchText: readString(STORAGE_KEYS.casinoSearchText, ''),
        sortFieldType: hydrateSortFieldType(),
    },
    auth: null,
    userPoints: null,
    userPreferences: {
        displayCraps: true,
        displayBlackjack: true,
        displayRoulette: true,
    },
    isOnMobileDevice: false,
    clientConfig: null,
    homeFavoritesOnly: readBool(STORAGE_KEYS.homeFavoritesOnly, false),
    favoriteOverrides: {},
    pwa: {
        updateAvailable: false,
        offlineReady: false,
        isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
    },
}